import * as React from 'react';

export default {
  ML: React.lazy(
    () =>
      import(
        /* webpackChunkName: "ml" */
        './'
      ),
  ),
  MLModelDetail: React.lazy(
    () =>
      import(
        /* webpackChunkName: "ml-model-detail" */
        `./MLModelDetail`
      ),
  ),
  MLDatasetDetail: React.lazy(
    () =>
      import(
        /* webpackChunkName: "ml-dataset-detail" */
        `./MLDatasetDetail`
      ),
  ),
  MLModelRunDetail: React.lazy(
    () =>
      import(
        /* webpackChunkName: "ml-model-run-detail" */
        `./MLModelRunDetail`
      ),
  ),
  MLDatasetExample: React.lazy(
    () =>
      import(
        /* webpackChunkName: "ml-dataset-example" */
        `./MLDatasetExample`
      ),
  ),
  MLDatasetLabeling: React.lazy(
    () =>
      import(
        /* webpackChunkName: "ml-dataset-labeling" */
        `./MLDatasetLabeling`
      ),
  ),
};
